/**
 * package: com.inq.flash.client.data
 * class: ChatActivityMessage
 * @extends com.inq.flash.messagingframework.Message
 * @constructor
 */
com.inq.flash.client.data.ChatActivityMessage = function(chat,activityType,text,returnReceipt) {
	com.inq.flash.messagingframework.Message.call(this);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACTIVITY);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID,chat.getChatID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_TYPE,activityType);
	// Do encoding for chat.data on CR side to affect general CI and CEAPI
	if(text != null) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA, text);
    if (returnReceipt === undefined) {
        this.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT, "1");
    }
};
$hxClasses['com.inq.flash.client.data.ChatActivityMessage'] = com.inq.flash.client.data.ChatActivityMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatActivityMessage.__name__ = ["com","inq","flash","client","data","ChatActivityMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatActivityMessage.__super__ = com.inq.flash.messagingframework.Message;
for(var k in com.inq.flash.messagingframework.Message.prototype ) com.inq.flash.client.data.ChatActivityMessage.prototype[k] = com.inq.flash.messagingframework.Message.prototype[k];
/** @type {com.inq.flash.client.data.ChatActivityMessage} */
com.inq.flash.client.data.ChatActivityMessage.prototype.__class__ = com.inq.flash.client.data.ChatActivityMessage;
